import { render, staticRenderFns } from "./OgorNotifications.vue?vue&type=template&id=b6228238&scoped=true"
import script from "./OgorNotifications.vue?vue&type=script&lang=ts"
export * from "./OgorNotifications.vue?vue&type=script&lang=ts"
import style0 from "./OgorNotifications.vue?vue&type=style&index=0&id=b6228238&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6228238",
  null
  
)

export default component.exports